/** @jsxImportSource theme-ui */

type Props = {
  fill?: string;
};

const IconProjectSemiPermanent = ({ fill = "white", ...props }: Props) => (
  <svg viewBox="0 0 68 45" fill={fill} {...props}>
    <path d="M64.34 7.4c1.979 2.13 3.119 4.805 3.119 8.077 0 2.279-.521 4.263-1.436 5.943-1.87 3.432-5.53 5.499-10.751 5.499h-9.313V40.79h-6.935V3.935h15.949c4.164 0 7.336 1.238 9.367 3.465zM54.183 21.42c4.211 0 6.39-2.279 6.39-5.844 0-3.716-2.279-5.747-6.294-5.747h-8.32V21.42h8.224zM4.041 44.967C1.684 43.392.197 41.082.197 37.338c0-6.986 5.747-10.503 13.622-10.503 8.572 0 13.526 4.112 14.217 10.901h-6.687c-.544-3.617-3.272-5.648-7.626-5.648-4.117 0-6.839 1.732-6.839 4.656 0 3.418 3.567 4.31 9.265 5.499 2.97.646 5.802 1.428 8.098 2.724H4.041zM25.385 0H5.181c2.288 1.529 5.393 2.366 8.784 3.123 5.85 1.337 9.511 2.23 9.511 6.192 0 3.664-3.316 5.399-7.328 5.399-5.648 0-8.767-2.379-9.268-7.134H0c.296 7.532 5.993 12.633 16.098 12.633 8.174 0 14.316-4.111 14.316-11.442 0-4.51-2.048-7.085-5.029-8.771z" />
  </svg>
);

export default IconProjectSemiPermanent;
